import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

// Desktop cart — persisted in localStorage so it survives reload and syncs
// across tabs. Items are keyed by product_id + size to allow variants.
// Prices are ngwee (integer) — never store display strings.

export const useCart = create(
  persist(
    (set, get) => ({
      items: [],

      add: (item) => {
        const key = item.product_id + "|" + (item.size || "");
        const existing = get().items.find(
          (i) => i.product_id + "|" + (i.size || "") === key
        );
        if (existing) {
          set({
            items: get().items.map((i) =>
              i.product_id + "|" + (i.size || "") === key
                ? { ...i, qty: Math.min(i.qty + (item.qty || 1), i.stock_qty || 99) }
                : i
            ),
          });
        } else {
          set({ items: [...get().items, { qty: 1, ...item }] });
        }
      },

      bump: (key, delta) =>
        set({
          items: get()
            .items.map((i) =>
              i.product_id + "|" + (i.size || "") === key
                ? { ...i, qty: Math.max(1, Math.min((i.qty || 1) + delta, i.stock_qty || 99)) }
                : i
            ),
        }),

      remove: (key) =>
        set({ items: get().items.filter((i) => i.product_id + "|" + (i.size || "") !== key) }),

      clear: () => set({ items: [] }),

      subtotalNgwee: () => get().items.reduce((s, i) => s + (i.price || 0) * (i.qty || 0), 0),
      count: () => get().items.reduce((s, i) => s + (i.qty || 0), 0),

      bySeller: () => {
        const map = new Map();
        for (const i of get().items) {
          const k = i.seller_id || "unknown";
          if (!map.has(k)) map.set(k, { seller_id: i.seller_id, seller_name: i.seller_name, items: [] });
          map.get(k).items.push(i);
        }
        return Array.from(map.values());
      },
    }),
    {
      name: "kapio-cart",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
